import React from 'react';
import { getText } from '../../helpers';

const RiskProfileLoader = () => {
  const loadingMessage = getText('Loading Risk Profile');

  return (
    <div id="risk-profile-loading-message">
      <i className="loading circle notched icon plan-loading"></i>
      <span>{loadingMessage}</span>
    </div>
  )
}

export default RiskProfileLoader;


// WEBPACK FOOTER //
// ./src/views/risk_profile_tables/risk_profile_loader.js